import React, { useContext, useState } from "react";
import Loader from "components/loader";
import http from "utils/http";
import { endpoints } from "utils/endpoints";
import { useLocation } from "@reach/router";
import DataProvider from "Context/DataContext";
import ThankYouPopup from "../thankYouPopup";

const SendMail = ({ unSupportedFile }) => {
  const [email, setEmail] = useState("");
  const [loader, setLoader] = useState(false);
  const location = useLocation();
  const { quoteId } = useContext(DataProvider);
  const [open, setOpen] = useState(false);

  const handleSubmit = async () => {
    try {
      setLoader(true);
      await http().post(endpoints.forms.tailoredQuote, {
        email,
        quote_id: quoteId,
        pagelink: location.href,
      });
      setEmail("");
      setLoader(false);
      setOpen(true);
    } catch (error) {
      setLoader(false);
    }
  };

  return (
    <>
      <div
        className={`${
          !unSupportedFile && "hidden"
        } bg-[#FFE8E8] rounded flex flex-col gap-4 p-4 sm:mt-2 mt-6 w-full mb-4`}
      >
        <p className="text-xl font-semibold font-primary ">
          Let's Get Your Files Processed!
        </p>

        <p className="text-sm font-opensans text-[#2E2E2E]">
          No worries—we accept all formats. Enter your email for a quick,
          real-time tailored quote.
        </p>
        <div className="flex sm:flex-row flex-col gap-4">
          <input
            onChange={(e) => {
              setEmail(e.target.value);
            }}
            value={email}
            type="email"
            placeholder="Enter your email address"
            className="border border-[#B0B0B0] rounded-lg bg-white p-2 outline-none md:flex-[1.7] flex-1"
          />
          <button
            disabled={!email}
            onClick={handleSubmit}
            className="md:flex-[0.3] flex-1 bg-[#00173A] rounded-lg py-2 px-12  grid place-content-center text-base font-opensans text-white font-semibold"
          >
            {loader ? <Loader /> : "Submit"}
          </button>
        </div>
        <p className=" text-[10px] font-opensans text-[#2E2E2E] ">*will only be used to contact you once</p>
      </div>
      {open && <ThankYouPopup open={open} setOpen={setOpen} />}
    </>
  );
};

export default SendMail;
